import React, {FC, memo} from "react";
import Form, {FormItemProps} from "antd/lib/form";
import {Select} from "antd";
import {SelectProps} from "antd/lib/select";
import classnames from "classnames";
import css from "./CourseCycleInput.less";
import i18n from "../../services/i18n";
import {CourseCycle} from "../../generated/graphql";
import {getPopupContainer} from "../../helpers/getPopupContainer";

type CourseCycleInputProps = Pick<
    FormItemProps,
    "validateStatus" | "help" | "label"
> &
    Pick<
        SelectProps<CourseCycle>,
        "onChange" | "onBlur" | "value" | "placeholder"
    > & {
        isGreyedOut?: boolean;
        style?: React.CSSProperties;
        testId?: string;
    };

const CourseCycleInput: FC<CourseCycleInputProps> = ({
    label,
    placeholder,
    testId,
    validateStatus,
    help,
    value,
    onBlur,
    onChange,
    isGreyedOut,
    ...props
}) => {
    return (
        <div
            className={classnames(css.root, {[css.isGreyedOut]: isGreyedOut})}
            data-testid={testId}
            {...props}
        >
            <Form.Item
                label={label}
                validateStatus={validateStatus}
                help={help}
                required
            >
                <Select<CourseCycle>
                    placeholder={placeholder}
                    onChange={onChange}
                    onBlur={onBlur}
                    value={value}
                    getPopupContainer={getPopupContainer}
                >
                    <Select.Option
                        key={CourseCycle.Weekly}
                        value={CourseCycle.Weekly}
                    >
                        {i18n.containers.courses.CourseCreate.courseCycle.cycles.weekly()}
                    </Select.Option>
                    <Select.Option
                        key={CourseCycle.EveryTwoWeeks}
                        value={CourseCycle.EveryTwoWeeks}
                    >
                        {i18n.containers.courses.CourseCreate.courseCycle.cycles.everyTwoWeeks()}
                    </Select.Option>
                    <Select.Option
                        key={CourseCycle.Monthly}
                        value={CourseCycle.Monthly}
                    >
                        {i18n.containers.courses.CourseCreate.courseCycle.cycles.monthly()}
                    </Select.Option>
                    <Select.Option
                        key={CourseCycle.Custom}
                        value={CourseCycle.Custom}
                    >
                        {i18n.containers.courses.CourseCreate.courseCycle.cycles.custom()}
                    </Select.Option>
                </Select>
            </Form.Item>
        </div>
    );
};

export default memo(CourseCycleInput);
